import { ReactComponent as CelebrationIcon } from "@Assets/All/2hand-celebration-emoji.svg";
import { ReactComponent as WavingHand } from "@Assets/homePage/emoji _waving hand.svg";
import { ReactComponent as HornsIcon } from "@Assets/homePage/horns-emoji.svg";
import { ReactComponent as VictoryHandICon } from "@Assets/homePage/victory-hand-emoji.svg";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Flex } from "features/comments/modals/comment-center.style";
import { Button, IconDispatcher } from "shared/ui-basics";
import { useHistory } from "react-router-dom";
import { UserType } from "utils/optionsSets/OptionSets";
import { currentWorkspaceId } from "index";
import { findWorkspaceById } from "redux/memoizedSelectors";
import { useGetIsLoggedUserWorkspaceOwner } from "shared/hooks";

export const Header = () => {
	const { t } = useTranslation();
	const history = useHistory();

	const loggerUserInfo = useSelector((state: any) => state?.auth?.userInfo);
	const currentWorkspace = useSelector(findWorkspaceById(currentWorkspaceId));
	const isWorkspaceOWner = useGetIsLoggedUserWorkspaceOwner(currentWorkspace);
	const loggerUserType = Number(loggerUserInfo.UserType);
	const isShowInvite = isWorkspaceOWner || loggerUserType === UserType.companyAdmin || loggerUserType === UserType.admin;

	return (
		<Container>
			<Flex align="center">
				{t(getCorrectTime())}
				{loggerUserInfo?.UserFullName?.split(" ")[0]}
				{IconHomeValidation(getCorrectTime())}
			</Flex>
            {isShowInvite && (
                <div>
                    <Button variant="dark-outline" size="s" onClick={() => history.push(`/users`)}>
                        <IconDispatcher type="user-plus" styling="me-2" />
                        <div>{t("INVITE")}</div>
                    </Button>
                </div>
            )}
		</Container>
	);
};

const getCorrectTime = () => {
	const now = new Date();
	if (now.getHours() > 5 && now.getHours() < 12) return "GOOD_MORNING";
	if (now.getHours() >= 12 && now.getHours() <= 18) return "GOOD_AFTERNOON";
	if (now.getHours() > 18 && now.getHours() <= 22) return "GOOD_EVENING";
	if (now.getHours() > 22 || now.getHours() <= 5) return "GOOD_NIGHT";
};

const IconHomeValidation = (type) => {
	switch (type) {
		case "GOOD_MORNING":
			return <WavingHand className="ms-2" />;
		case "GOOD_NIGHT":
			return <HornsIcon className="ms-2" />;
		case "GOOD_AFTERNOON":
			return <CelebrationIcon className="ms-2" />;
		case "GOOD_EVENING":
			return <VictoryHandICon className="ms-2" />;
		default:
			return <WavingHand className="ms-2" />;
	}
};

const Container = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 32px;
	font-style: normal;
	font-weight: 600;
	padding-bottom: 32px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
